import headerBg from '@/assets/images/active/sakura/portrait/header/header_bg.png';
import headerBg2 from '@/assets/images/active/sakura/portrait/header/header_bg2.png';
import officeBtn from '@/assets/images/active/sakura/portrait/header/btn_05.png';
import loginBtn from '@/assets/images/active/sakura/portrait/header/btn_06.png';
import accountBtn from '@/assets/images/active/sakura/portrait/header/btn_07.png';
import activeBtn from '@/assets/images/active/sakura/portrait/header/btn_09.png';
import logoutBtn from '@/assets/images/active/sakura/portrait/header/btn_10.png';

export const headerConfig = {
    not_logged_in: {
        background_image: headerBg,
        style: ''
    },
    logged_in: {
        background_image: headerBg2,
        main_title_color: '#fff',
        sub_title_color: '#fff',
        tips_color: '#fff',
        game_name: '魔卡少女樱：回忆钥匙'
    },
    operation_btn: {
        office_website: {
            width: '',
            height: '',
            background_image: '',
            img: officeBtn,
            style: '',
            link: 'https://sakura.qingcijoy.com/official/index.html'
        },
        login: {
            width: '',
            height: '',
            background_image: '',
            img: loginBtn,
            style: ''
        },
        change_account: {
            width: '',
            height: '',
            background_image: '',
            img: accountBtn,
            style: ''
        },
        join_active: {
            width: '',
            height: '',
            background_image: '',
            img: activeBtn,
            style: '',
            link: 'https://sakura.qingcijoy.com/pre-registration/index.html'
        },
        logout: {
            width: '',
            height: '',
            img: logoutBtn,
            style: ''
        }
    }
};


// WEBPACK FOOTER //
// ./src/pages/sakura/headerConfig.js